__turbopack_context__.v({
  "hidden-desktop": "Navigation-module-scss-module__vlB8mq__hidden-desktop",
  "hidden-mobile": "Navigation-module-scss-module__vlB8mq__hidden-mobile",
  "is-active": "Navigation-module-scss-module__vlB8mq__is-active",
  "link": "Navigation-module-scss-module__vlB8mq__link",
  "menu-toggle": "Navigation-module-scss-module__vlB8mq__menu-toggle",
  "site-nav": "Navigation-module-scss-module__vlB8mq__site-nav",
});
